module.exports = __webpack_public_path__ + "media/club_deals/strategies_horizontal_card3-33a120f7.webp";